import dayjs from 'dayjs';

// --- Sort helpers (server-side sorting) ---
export const DEFAULT_SORT = { sortBy: 'dueDate', sortOrder: 'ASC' };
export const SORTABLE_COLUMNS = ['dueDate', 'clientName', 'source', 'status'];

// Status is derived from the due date (overdue = due before today), so sorting by status is a
// due-date sort in the opposite direction: ascending puts ACTIVE (later due dates) first.
export const toApiSort = (sortBy, sortOrder) => {
  if (sortBy === 'status') {
    return { sortBy: 'dueDate', sortOrder: sortOrder === 'ASC' ? 'DESC' : 'ASC' };
  }
  return { sortBy, sortOrder };
};

export const flipSort = order => (order === 'ASC' ? 'DESC' : 'ASC');

export const getColumnSortOrder = (columnKey, sortBy, sortOrder) => {
  if (columnKey !== sortBy) return null;
  return sortOrder === 'ASC' ? 'ascend' : 'descend';
};

// --- Filter helpers ---
export const toDayjsRange = range => (range ? range.map(date => dayjs(date)) : null);

// Values match the API's source categories; labels match what the Source column shows.
export const SOURCE_OPTIONS = [
  { label: 'Manual Reminder', value: 'manual' },
  { label: 'Sales Opportunity', value: 'salesOpp' },
  { label: 'Client Event', value: 'customEvent' },
  { label: 'Life Event', value: 'lifeEvent' },
  { label: 'Tag', value: 'tag' },
  { label: 'Sales Trigger', value: 'salesTrigger' },
  { label: 'Inquiry', value: 'inquiry' },
];

export const STATUS_OPTIONS = [
  { label: 'Active', value: 'active' },
  { label: 'Overdue', value: 'overdue' },
];

// --- Filter state (Filter dropdown + chips, same shape as Appointments' ReportFilter) ---
export const DEFAULT_FILTERS = { associateIds: [], sources: [], statuses: [] };

// ReportFilter's Cascader reports its selection as [filterKey, value] pairs.
export const filtersFromSelection = selection =>
  selection.reduce((acc, [key, value]) => (key in acc && value ? { ...acc, [key]: [...acc[key], value] } : acc), {
    associateIds: [],
    sources: [],
    statuses: [],
  });

// Active and Overdue together cover every open reminder, so only a single pick narrows the list.
export const statusFromFilters = statuses => (statuses?.length === 1 ? statuses[0] : null);

// Turns the due-date range and status filter into the API's fromDueDate/toDueDate. A reminder is
// overdue once its due date is before today (the OVERDUE badge's "due date + 1 day" check).
export const resolveDueDateBounds = (dueDateRange, status, now = dayjs()) => {
  const today = dayjs(now).startOf('day');
  let from = dueDateRange?.[0] ? dayjs(dueDateRange[0]).startOf('day') : null;
  let to = dueDateRange?.[1] ? dayjs(dueDateRange[1]).startOf('day') : null;
  if (status === 'active' && (!from || from.isBefore(today))) {
    from = today;
  }
  if (status === 'overdue') {
    const yesterday = today.subtract(1, 'day');
    if (!to || to.isAfter(yesterday)) {
      to = yesterday;
    }
  }
  return {
    ...(from ? { fromDueDate: from.format('YYYY-MM-DD') } : {}),
    ...(to ? { toDueDate: to.format('YYYY-MM-DD') } : {}),
  };
};
